import React from 'react';
import { EntityForm } from '../../../widgets/Forms';
import { SelectItem } from '../../../widgets/SelectItem';
import { LookupField } from '../../../widgets/LookupField';
import EmployerSearch from '../../employer/EmployerSearch';


export default function GrantClaimFormReversalSearchForm(props) {

    return (
        <EntityForm ref={React.createRef()} viewId="GrantClaimFormReversalSearchForm" values={props.data}
            useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="GrantClaimFormReversalSearchForm">
                    <td>
                        <SelectItem
                            dataUrl={"api/sims/GrantClaimFormReversal/GetLookupList?listId=DGType"}
                            id="DiscretionaryGrantTypeID"
                            label="Intervention Type"
                            className="w-150"
                            form={form}
                            InputProps={{
                                readOnly: props.disableFields
                            }}
                        />
                    </td>
                    <td>
                        <LookupField
                            id="EmployerID"
                            label="Employer"
                            className="w-100"
                            form={form}
                        >
                            <EmployerSearch showTitle={false} mode='lookup' dataUrl="api/sims/GrantClaimFormReversal/EmployerSearch"
                                onLookupValueChange={(value) => {
                                    form.setLookupSelection("EmployerID", value)
                                }} autoFetchData={false} selection={props.selection} />
                        </LookupField>
                    </td>
                    <br>
                    </br>
                </form>
            }
        </EntityForm>
    );
}
